const { useMantineTheme } = require('@mantine/core');
const { useState } = require('react');

const DivButton = (props) => {
    const [btnHover, setBtnHover] = useState(false);
    const theme = useMantineTheme();
    let baseColor = props.variant && props.variant === 'light' ? theme.fn.rgba(theme.colors[props.color][7], 0.2) : theme.colors[props.color][9];

    let fontColor = props.variant && props.variant === 'light' ? theme.fn.rgba(theme.colors[props.color][1], 0.9) : theme.fn.rgba(theme.white, 0.9);

    fontColor = theme.colorScheme === 'light' && props.variant === 'light' ? theme.white : fontColor;
    baseColor = theme.colorScheme === 'light' ? theme.colors[props.color][6] : baseColor;
    const hoverColor = theme.colorScheme === 'dark' ? theme.fn.rgba(baseColor, 0.25) : theme.fn.rgba(theme.colors[props.color][6],.08);

    let border = 'none';
    if(props.variant && props.variant === 'outline'){
        border = theme.colorScheme === 'dark'?`1px solid ${theme.colors[props.color][5]}`:`1px solid ${theme.colors[props.color][4]}`;
        baseColor = 'transparent';
        fontColor = theme.colorScheme === 'dark'?theme.colors[props.color][5]:theme.colors[props.color][4];
    }

    const disabled = props.disabled ? true : false;
    
    // Apply disabled styling
    const disabledOpacity = 0.5;
    const disabledCursor = 'not-allowed';
    const disabledBackgroundColor = theme.colorScheme === 'dark' 
        ? theme.colors.gray[8] 
        : theme.colors.gray[2];
    const disabledColor = theme.colorScheme === 'dark' 
        ? theme.colors.gray[5] 
        : theme.colors.gray[6];
    
    const handleClick = (e) => {
        if (!disabled && props.onClick) {
            props.onClick(e);
        }
    };

    const handleMouseOver = () => {
        if (!disabled) {
            setBtnHover(true);
        }
    };

    const handleMouseOut = () => {
        if (!disabled) {
            setBtnHover(false);
        }
    };
    
    return (
        <>
            <div
                style={{
                    display: 'inline-block',
                    padding: '10px 20px',
                    fontWeight: 600,
                    backgroundColor: disabled 
                        ? disabledBackgroundColor 
                        : (btnHover ? hoverColor : baseColor),
                    color: disabled ? disabledColor : fontColor,
                    border: border,
                    borderRadius: '5px',
                    cursor: disabled ? disabledCursor : 'pointer',
                    textAlign: 'center',
                    textDecoration: 'none',
                    fontSize: '14px',
                    lineHeight:'normal',
                    opacity: disabled ? disabledOpacity : 1,
                    pointerEvents: disabled ? 'none' : 'auto',
                }}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                onClick={handleClick}>
                {props.children}
            </div>
        </>
    );
};

export default DivButton;
